
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}},[_c('path',{attrs:{"d":"M37 22H12a1 1 0 000 2h25a1 1 0 000-2zM12 16h10a1 1 0 000-2H12a1 1 0 000 2zM38 31a1 1 0 00-1-1H12a1 1 0 000 2h25a1 1 0 001-1zM30 39a1 1 0 00-1-1H12a1 1 0 000 2h17a1 1 0 001-1zM12 46a1 1 0 000 2h14a1 1 0 000-2H12z"}}),_c('path',{attrs:{"d":"M3 2h29v14h14v17h2V14.586L33.414 0H1v60h31v-2H3V2zm31 1.414L44.586 14H34V3.414z"}}),_c('path',{attrs:{"d":"M35 36v24h24V36H35zm22 22h-9V45.414l4.293 4.293 1.414-1.414L47 41.586l-6.707 6.707 1.414 1.414L46 45.414V58h-9V38h20v20z"}})])
      }
    
      }
    